import { Mail, Phone, MapPin, Send } from "lucide-react";
import SEO from "@/components/SEO";

const SUPPORT_EMAIL = "support@scudononni.it";

export default function Contatti() {
  return (
    <div data-testid="contatti-page" className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <SEO
        path="/contatti"
        title="Contatti"
        description="Scrivi a support@scudononni.it per qualsiasi domanda, segnalazione o suggerimento. In caso di truffa in corso chiama subito 112 o la Polizia di Stato."
      />
      <div className="text-center mb-12 animate-fade-up">
        <Send size={56} className="mx-auto text-[#22C55E] mb-5" />
        <h1 className="font-heading text-4xl md:text-5xl font-extrabold text-[#1E3A8A] leading-tight">
          Contattaci
        </h1>
        <p className="mt-5 text-xl md:text-2xl text-gray-700 leading-relaxed">
          Hai una domanda, una segnalazione o vuoi raccontarci la tua esperienza?
          Siamo felici di sentirti.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          data-testid="contact-email-card"
          className="bg-white p-8 rounded-3xl shadow-lg border-4 border-blue-50 hover:border-[#1E3A8A] hover:shadow-xl transition-all active:scale-[0.98]"
        >
          <div className="w-16 h-16 rounded-2xl bg-[#DBEAFE] flex items-center justify-center text-[#1E3A8A] mb-5">
            <Mail size={32} />
          </div>
          <h3 className="font-heading text-2xl font-bold text-[#1E3A8A] mb-2">Scrivici un'email</h3>
          <p className="text-lg text-gray-700 mb-3">Ti risponderemo entro pochi giorni lavorativi.</p>
          <p className="text-xl font-bold text-[#1E3A8A] break-all">{SUPPORT_EMAIL}</p>
        </a>

        <div className="bg-white p-8 rounded-3xl shadow-lg border-4 border-blue-50">
          <div className="w-16 h-16 rounded-2xl bg-[#DCFCE7] flex items-center justify-center text-[#16A34A] mb-5">
            <Phone size={32} />
          </div>
          <h3 className="font-heading text-2xl font-bold text-[#1E3A8A] mb-2">In caso di truffa in corso</h3>
          <p className="text-lg text-gray-700 mb-3">
            Non aspettare la nostra risposta: chiama subito le forze dell'ordine.
          </p>
          <div className="space-y-2">
            <a href="tel:112" className="block text-xl font-bold text-[#1E3A8A]">112 — Emergenze</a>
            <a href="tel:0646541" className="block text-xl font-bold text-[#1E3A8A]">06 46541 — Polizia di Stato</a>
          </div>
        </div>
      </div>

      <div className="mt-10 bg-[#DCFCE7] border-4 border-[#22C55E] rounded-[2rem] p-8 md:p-10">
        <div className="flex items-start gap-4">
          <div className="w-14 h-14 rounded-2xl bg-white flex items-center justify-center text-[#16A34A] flex-shrink-0">
            <MapPin size={28} />
          </div>
          <div>
            <h3 className="font-heading text-2xl font-bold text-[#14532D] mb-2">
              Hai ricevuto una truffa interessante?
            </h3>
            <p className="text-lg text-[#14532D] leading-relaxed">
              Inviacela via email: ci aiuterai a migliorare ScudoNonni e a proteggere altri nonni
              da nuove tipologie di truffa. Grazie!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
